import { NavigatorParams } from 'common/constants/navigator-params';
import { FormAutoSaver } from 'common/helpers/form-auto-saver';
import { PreviousNavigation } from 'common/helpers/previous-navigation';

export default function clearStorage() {
  NavigatorParams.remove();
  FormAutoSaver.remove();
  PreviousNavigation.remove();
}
